import {SET_ENV_VARIABLE} from './types'

export const envAction = (env:String) => {
    return {
        type: SET_ENV_VARIABLE,
        env: env
    }
}